import { AppStatus } from '../enums/appStatus';
import { StoreContext } from '../models/store/context';

export const initialContext: StoreContext = {
  app: {
    status: AppStatus.IDLE,
    session: null,
    catalogue: null,
  },
  form: {},
};
